import type { Room } from 'matrix-js-sdk';
import { lowercaseFirstLetter } from 'utils/stringHelper';
import type { AnnouncementsType } from '../../components/AnnouncementsList/AnnouncementsList';
import { useRoomTimeline } from '../../matrix/hooks/useRoomTimeline';
import { NotificationReason } from '../../utils/matrixClient';

export type MatrixAnnouncementContent = {
  type: NotificationReason;
  title: string;
  content: string;
};

export const useGetAnnouncements = (room?: Room): AnnouncementsType[] => {
  const messages = useRoomTimeline(room?.roomId ?? '');

  const announcements: AnnouncementsType[] = [];

  for (const event of messages) {
    if (event.getUnsigned()?.redacted_because?.type === 'm.room.redaction') {
      continue;
    }
    let msgBody: MatrixAnnouncementContent | null;
    try {
      msgBody = JSON.parse(event.getContent().body);
    } catch {
      msgBody = null;
    }

    const announcementTypes = [
      NotificationReason.OrganizationAnnouncement,
      NotificationReason.GroupAnnouncement,
      NotificationReason.CourseAnnouncement,
      //  supports legacy announcements
      'announcement',
    ];

    if (msgBody && announcementTypes.includes(lowercaseFirstLetter(msgBody.type) as NotificationReason)) {
      announcements.push({
        date: event.getDate() ?? new Date(),
        id: event.getId() ?? '',
        isUnread: false,
        title: msgBody.title ?? '',
        message: msgBody.content ?? '',
        matrixEvent: event,
      });
    }
  }
  return announcements;
};
